import Vue from 'vue';

const state = {
    documents: [],
};

const getters = {
    getDocuments(state) {
        return state.documents;
    }
};

const mutations = {
    SET_DATA(state, documents) {
        state.documents = documents;
    },
};

const actions = {

    loadDocuments: function ({dispatch, commit}, files) {

        let data = new FormData();

        for (let i = 0; i < files.length; i++) {
            data.append('documents[' + i + ']', files[i], files[i].name);
        }

        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/pircas/v1/documents/", data, config)
                .then(({data}) => {

                    const documents = [];

                    data.forEach((item) => {
                        documents.push({file: item, title: ''});
                    });

                    commit('SET_DATA', documents);
                    resolve();

                }).catch((response) => {
                const code = response.response.data.code;
                const httpCode = response.response.data.data.status;
                console.log(httpCode, code);
                reject();
            });

        });
    }

};

export const documents = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};